/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_VI_VN: Record<string, string> = {
    ariaAnnounceChart: 'biểu đồ, ${seriesCount}[number] chuỗi',
    ariaAnnounceFlowProportionLink: 'liên kết ${index} của ${count}, từ ${from} đến ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nút ${index} của ${count}, ${description}',
    ariaAnnounceGaugeChart: 'biểu đồ đồng hồ đo, ${caption}',
    ariaAnnounceHierarchyChart: 'biểu đồ phân cấp, ${caption}',
    ariaAnnounceHierarchyDatum: 'cấp độ ${level}[number], ${count}[number] con, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Nhấn Phím Cách hoặc Enter để chuyển đổi chế độ hiển thị',
    ariaLabelAddHorizontalLine: 'Thêm Đường Ngang',
    ariaLabelAnnotationOptionsToolbar: 'Tùy chọn Chú thích',
    ariaLabelAnnotationSettingsDialog: 'Cài đặt Chú thích',
    ariaLabelColorPicker: 'Trình chọn màu',
    ariaLabelFinancialCharts: 'Biểu đồ tài chính',
    ariaLabelLegend: 'Chú giải',
    ariaLabelLegendItem: '${label}, Mục chú giải ${index}[number] của ${count}[number]',
    ariaLabelLegendItemUnknown: 'Mục chú giải không xác định',
    ariaLabelLegendPageNext: 'Trang Chú Giải Tiếp Theo',
    ariaLabelLegendPagePrevious: 'Trang Huyền Thoại Trước',
    ariaLabelLegendPagination: 'Phân trang Chú giải',
    ariaLabelNavigator: 'Trình điều hướng',
    ariaLabelNavigatorMaximum: 'Tối đa',
    ariaLabelNavigatorMinimum: 'Tối thiểu',
    ariaLabelNavigatorRange: 'Phạm vi',
    ariaLabelRangesToolbar: 'Phạm vi',
    ariaLabelSettingsTabBar: 'Cài đặt',
    ariaLabelZoomToolbar: 'Thu phóng',
    ariaValuePanRange: '${min}[percent0to2dp] đến ${max}[percent0to2dp]',
    contextMenuDownload: 'Tải về',
    contextMenuPanToCursor: 'Chuyển đến đây',
    contextMenuToggleOtherSeries: 'Chuyển đổi các dòng khác',
    contextMenuToggleSeriesVisibility: 'Chuyển đổi Hiển thị',
    contextMenuZoomToCursor: 'Thu phóng tới đây',
    dialogHeaderChannel: 'Kênh',
    dialogHeaderDatePriceRange: 'Ngày và Giá',
    dialogHeaderDateRange: 'Khoảng thời gian',
    dialogHeaderFibonacciRange: 'Fib Hồi Quy',
    dialogHeaderLine: 'Đường kẻ',
    dialogHeaderPriceRange: 'Khoảng Giá',
    dialogHeaderText: 'Văn bản',
    dialogInputAlign: 'Căn chỉnh',
    dialogInputColorPicker: 'Màu sắc',
    dialogInputColorPickerAltText: 'Màu chữ',
    dialogInputExtendAbove: 'Mở rộng lên trên',
    dialogInputExtendBelow: 'Mở rộng xuống dưới',
    dialogInputExtendChannelEnd: 'Kéo dài cuối kênh',
    dialogInputExtendChannelStart: 'Mở rộng kênh bắt đầu',
    dialogInputExtendLeft: 'Kéo dài sang trái',
    dialogInputExtendLineEnd: 'Mở rộng cuối dòng',
    dialogInputExtendLineStart: 'Kéo dài điểm bắt đầu đường thẳng',
    dialogInputExtendRight: 'Mở rộng sang phải',
    dialogInputFibonacciBands: 'Dải',
    dialogInputFibonacciBandsAltText: 'Dải Fibonacci',
    dialogInputFillColorPicker: 'Tô màu',
    dialogInputFillColorPickerAltText: 'Màu tô',
    dialogInputFontSize: 'Kích thước',
    dialogInputFontSizeAltText: 'Kích Thước Chữ',
    dialogInputLineStyle: 'Gạch nối',
    dialogInputPosition: 'Vị trí',
    dialogInputReverse: 'Đảo ngược',
    dialogInputShowFill: 'Hiện Điền',
    dialogInputStrokeWidth: 'Độ dày',
    dialogInputStrokeWidthAltText: 'Độ dày đường kẻ',
    iconAltTextAlignCenter: 'Căn giữa',
    iconAltTextAlignLeft: 'Trái',
    iconAltTextAlignRight: 'Phải',
    iconAltTextClose: 'Đóng',
    iconAltTextLineStyleDashed: 'Gạch ngang dài',
    iconAltTextLineStyleDotted: 'Gạch ngắn',
    iconAltTextLineStyleSolid: 'Liền mạch',
    iconAltTextPositionBottom: 'Dưới cùng',
    iconAltTextPositionCenter: 'Giữa',
    iconAltTextPositionTop: 'Trên cùng',
    inputTextareaPlaceholder: 'Thêm Văn Bản',
    measurerDateRangeBars: '${value}[number] thanh',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Thể tích ${value}',
    overlayLoadingData: 'Đang tải dữ liệu...',
    overlayNoData: 'Không có dữ liệu để hiển thị',
    overlayNoVisibleSeries: 'Không có dãy số hiển thị',
    overlayUnsupportedBrowser: 'Phiên bản trình duyệt không tương thích. Vui lòng nâng cấp trình duyệt của bạn.',
    seriesHistogramTooltipCount: '${yName} (số đếm)',
    seriesHistogramTooltipFrequency: 'Tần suất',
    seriesHistogramTooltipMean: '${yName} (trung bình)',
    seriesHistogramTooltipSum: '${yName} (tổng)',
    toolbarAnnotationsArrow: 'Mũi tên',
    toolbarAnnotationsArrowDown: 'Mũi tên xuống',
    toolbarAnnotationsArrowUp: 'Mũi tên lên',
    toolbarAnnotationsCallout: 'Chú thích',
    toolbarAnnotationsClearAll: 'Xóa tất cả',
    toolbarAnnotationsComment: 'Bình luận',
    toolbarAnnotationsDatePriceRange: 'Ngày và Giá',
    toolbarAnnotationsDateRange: 'Khoảng thời gian',
    toolbarAnnotationsDelete: 'Xóa',
    toolbarAnnotationsDisjointChannel: 'Kênh không liên tục',
    toolbarAnnotationsDragHandle: 'Kéo Thanh Công Cụ',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Phục hồi',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Đường xu hướng dựa trên Fibonacci',
    toolbarAnnotationsFillColor: 'Màu nền',
    toolbarAnnotationsHorizontalLine: 'Đường Ngang',
    toolbarAnnotationsLineAnnotations: 'Đường Xu Hướng',
    toolbarAnnotationsLineColor: 'Màu Đường',
    toolbarAnnotationsLineStrokeWidth: 'Độ rộng nét vẽ',
    toolbarAnnotationsLineStyle: 'Kiểu Đường',
    toolbarAnnotationsLock: 'Khóa',
    toolbarAnnotationsMeasurerAnnotations: 'Công cụ đo lường',
    toolbarAnnotationsNote: 'Ghi chú',
    toolbarAnnotationsParallelChannel: 'Kênh Song Song',
    toolbarAnnotationsPriceRange: 'Khoảng Giá',
    toolbarAnnotationsQuickDatePriceRange: 'Đo lường',
    toolbarAnnotationsSettings: 'Cài đặt',
    toolbarAnnotationsShapeAnnotations: 'Mũi tên',
    toolbarAnnotationsText: 'Văn bản',
    toolbarAnnotationsTextAnnotations: 'Chú thích văn bản',
    toolbarAnnotationsTextColor: 'Màu chữ',
    toolbarAnnotationsTextSize: 'Kích Thước Văn Bản',
    toolbarAnnotationsTrendLine: 'Đường xu hướng',
    toolbarAnnotationsUnlock: 'Mở khóa',
    toolbarAnnotationsVerticalLine: 'Đường thẳng đứng',
    toolbarRange1Month: '1T',
    toolbarRange1MonthAria: '1 tháng',
    toolbarRange1Year: '1N',
    toolbarRange1YearAria: '1 năm',
    toolbarRange3Months: '3 Tháng',
    toolbarRange3MonthsAria: '3 tháng',
    toolbarRange6Months: '6T',
    toolbarRange6MonthsAria: '6 tháng',
    toolbarRangeAll: 'Tất cả',
    toolbarRangeAllAria: 'Tất cả',
    toolbarRangeYearToDate: 'Từ đầu năm đến nay',
    toolbarRangeYearToDateAria: 'Từ đầu năm đến nay',
    toolbarSeriesTypeCandles: 'Nến',
    toolbarSeriesTypeDropdown: 'Loại Biểu Đồ',
    toolbarSeriesTypeHighLow: 'Cao Thấp',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Nến Rỗng',
    toolbarSeriesTypeLine: 'Đường',
    toolbarSeriesTypeLineWithMarkers: 'Đường có điểm đánh dấu',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Đường bậc thang',
    toolbarZoomPanEnd: 'Di chuyển đến cuối',
    toolbarZoomPanLeft: 'Di chuyển sang trái',
    toolbarZoomPanRight: 'Di chuyển sang phải',
    toolbarZoomPanStart: 'Di chuyển ngang trở lại đầu trang',
    toolbarZoomReset: 'Đặt lại thu phóng',
    toolbarZoomZoomIn: 'Thu nhỏ',
    toolbarZoomZoomOut: 'Thu nhỏ',
    tooltipPaginationStatus: '${index}[number] trong số ${count}[number]',
};
